import { Box, Flex } from '@rebass/grid';
import { addGenericTags } from 'helpers/tracking/utm';
import { getTranslationForCoinDescription } from 'helpers/translation';
import React from 'react';
import { ElementType } from 'react';
import { useTranslation } from 'react-i18next';
import {
  FaBitcoin,
  FaDiscord,
  FaEnvelope,
  FaFacebookF,
  FaFileAlt,
  FaGithub,
  FaGlobeAmericas,
  FaLinkedinIn,
  FaReddit,
  FaRss,
  FaSlack,
  FaTelegramPlane,
  FaTwitter,
  FaWeixin,
} from 'react-icons/fa';
import { CoinInfo, CoinUri } from 'store/Coin/Info/types';
import { Coin } from 'store/Coin/types';
import { Currency } from 'store/Currency/types';
import withCurrency from 'store/Currency/with-currency';

import withContainer from './container';
import { IconWrapper, Text, Title, UriItem, UriLink } from './styles';

interface Props {
  coin: Coin;
  coinInfo: CoinInfo | null;
  Wrapper: ElementType;
  currency: Currency;
}

const UriIcon = (props: { type: string }) => {
  const { type } = props;

  switch (type) {
    case 'website':
      return <FaGlobeAmericas />;
    case 'whitepaper':
      return <FaFileAlt />;
    case 'facebook':
      return <FaFacebookF />;
    case 'twitter':
      return <FaTwitter />;
    case 'github':
      return <FaGithub />;
    case 'reddit':
      return <FaReddit />;
    case 'telegram':
      return <FaTelegramPlane />;
    case 'bitcoinTalk':
      return <FaBitcoin />;
    case 'blog':
      return <FaRss />;
    case 'discord':
      return <FaDiscord />;
    case 'slack':
      return <FaSlack />;
    case 'linkedIn':
      return <FaLinkedinIn />;
    case 'email':
      return <FaEnvelope />;
    case 'weChat':
      return <FaWeixin />;
  }

  return null;
};

const Uri = (props: { uri: CoinUri }) => {
  const { t } = useTranslation();
  const { uri } = props;

  if (Object.keys(uri).length === 0) {
    return null;
  }

  return (
    <Flex flexWrap="wrap">
      {Object.entries(uri).map(([key, value]) => {
        if (!value) {
          return null;
        }

        return (
          <UriItem key={`uri-${key}`} width={1 / 2}>
            <UriLink
              href={`${key === 'email' ? 'mailto:' : ''}${addGenericTags(
                value,
              )}`}
              target="_blank"
            >
              <IconWrapper>
                <UriIcon type={key} />
              </IconWrapper>
              {t(`social-media.${key}`)}
            </UriLink>
          </UriItem>
        );
      })}
    </Flex>
  );
};

const MarketsDetailInfo = (props: Props) => {
  const { t } = useTranslation();
  const { coinInfo, Wrapper, currency, coin } = props;

  if (
    !coinInfo ||
    (coinInfo.description === null && Object.keys(coinInfo.uri).length === 0)
  ) {
    return null;
  }

  const descriptionHtml = (coinInfo.description || '').replace(/\n/g, '<br />');
  const { uri } = coinInfo;

  return (
    <Wrapper>
      <Flex flexWrap="wrap">
        <Box mr={[0, '10px']} flex={['none', 'none', 1]} width={[1, 1, 'auto']}>
          <Title>{t('assets.detail.info.title')}</Title>
          <Text
            dangerouslySetInnerHTML={{
              __html:
                descriptionHtml ||
                getTranslationForCoinDescription(t, coin, currency),
            }}
          />
        </Box>
        <Box ml={[0, 0, '10px']} pt={['25px']} width={[1, 1, 300]}>
          <Uri uri={uri} />
        </Box>
      </Flex>
    </Wrapper>
  );
};

export default withContainer(withCurrency(MarketsDetailInfo));
